<template>
  <div>
    <GlobalError />
    <Header />
    <router-view></router-view>
    <SessionExpiredModal v-model:isOpen="isSessionExpired" />
  </div>
</template>

<script lang="ts">
  import { defineComponent, onMounted, onUnmounted } from 'vue'
  import Header from './components/Header/Header.vue'
  import GlobalError from './components/BaseComponents/GlobalError.vue'
  import SessionExpiredModal from './components/BaseComponents/SessionExpiredModal.vue'
  import { useSessionTimeout } from '@/composables/useSessionTimeout'

  import {
    setupInactivityHandler,
    stopInactivityHandler,
  } from '@/utils/inactivityHandler'
  import { useUserStore } from '@/stores/userStore'

  export default defineComponent({
    name: 'App',
    components: {
      Header,
      GlobalError,
      SessionExpiredModal,
    },
    setup() {
      const userStore = useUserStore()
      const { isSessionExpired, startSessionTimer } = useSessionTimeout()

      onMounted(() => {
        const cleanup = startSessionTimer()
        onUnmounted(cleanup)
        if (userStore.isLoggedIn) {
          setupInactivityHandler(userStore)
        }
      })

      onUnmounted(() => {
        stopInactivityHandler()
      })

      return {
        isSessionExpired,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .logo {
    height: 6em;
    padding: 1.5em;
    will-change: filter;
    transition: filter 300ms;
  }
  .logo:hover {
    filter: drop-shadow(0 0 2em #646cffaa);
  }
  .logo.vue:hover {
    filter: drop-shadow(0 0 2em #42b883aa);
  }

  .dev-details {
    background: white;
    padding: 1em;
    margin-top: 2rem;
    border-top: 1px solid #ccc;
    color: black;
    pre {
      text-align: left;
      white-space: pre-wrap;
      color: black;
    }
  }
</style>
